import { Injectable } from "@angular/core";
import { ValidatorFn } from '@angular/forms';

@Injectable({ providedIn: "root" })
export class CheckboxValidator {

  constructor() { }

  atLeastOneChecked(minRequired = 1): ValidatorFn {
    return function validate(formGroup: any) {
      let checked = 0;

      Object.keys(formGroup.controls).forEach(key => {
        const control = formGroup.controls[key];

        if (control.value === true) {
          checked++;
        }
      });

      if (checked < minRequired) {
        return {
          requireCheckboxToBeChecked: true,
        };
      }

      return null;
    };
  }
}
